/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=4c05b388&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=4c05b388&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.2.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c05b388"]])

export default __exports__